<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline">
        <div
          class="input-group input-prepend input-append item-mb"
          v-for="(skill, index) in editSkills"
          :key="index"
        >
          <vue-autosuggest
            v-model="editSkills[index]"
            :suggestions="[{ data: suggestions }]"
            :input-props="{ type: 'text', placeholder: 'skill' }"
            @focus="onFocus(index)"
            @selected="onSelected"
          >
            <template slot-scope="{ suggestion }">
              <span class="my-suggestion-item">{{ suggestion.item }}</span>
            </template>
          </vue-autosuggest>
          <a
            href="javascript:void(0)"
            class="input-prepend-btn"
            @click="addSkill(index)"
          >
            <i class="material-icons-outlined align-middle">add</i>
          </a>
          <a
            href="javascript:void(0)"
            class="input-apend-btn"
            @click="deleteSkill(index)"
          >
            <i class="material-icons-outlined align-middle">delete</i>
          </a>
        </div>
      </div>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          Edit Skills
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest";

export default {
  props: ["propsData", "suggestions"],
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  data() {
    return {
      focusedIndex: 0,
      editSkills: null,
    };
  },
  components: {
    VueAutosuggest,
  },
  created: function () {
    this.initData();
  },
  methods: {
    addSkill: function (index) {
      this.editSkills.splice(index + 1, 0, "");
    },
    deleteSkill: function (index) {
      this.editSkills.splice(index, 1);
      if (this.editSkills.length == 0) {
        this.editSkills.push("");
      }
    },
    initData: function () {
      const propsData = Object.assign([""], this.propsData);
      if (propsData) {
        this.editSkills = propsData;
      } else {
        this.editSkills = [""];
      }
    },
    onButtonClick: function () {
      const data = [];
      this.editSkills.forEach((item) => {
        if (item) {
          data.push(item);
        }
      });
      this.$emit("onButtonClick", data);
    },
    onFocus: function (index) {
      this.focusedIndex = index;
    },
    onSelected: function (item) {
      this.editSkills[this.focusedIndex] = item.item;
    },
  },
};
</script>

<style scoped>
.item-mb {
  margin-bottom: 8px;
}
</style>
